export default "__VITE_ASSET__46636698__"